import { takeLatest, put, call, select } from 'redux-saga/effects';
import { COPY_SUBSCRIPTION_SAGA } from "../sagaTypes";
import { loaderAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getSubscriptionsSagaAction, getUserInfoSagaAction } from "../sagaActions";

const request = data => {
    return fetch(`${ url }/copy_subscription`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerCopySubscription(args) {
    const user = yield select(state => state.user);
    const currentUser = yield select(state => state.currentUser);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('subscription_id', args.data.subscription_id);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Если добавляли абонемент на странице пользователя
            if (currentUser.id) {
                // Обновляем данные пользователя (с абонементами)
                yield put(getUserInfoSagaAction({ id: currentUser.id }));
            }
            // Если добавляли абонемент на странице с абонементами
            else {
                // Получение списка абонементов
                yield put(getSubscriptionsSagaAction());
            }

            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherCopySubscription() {
    yield takeLatest(COPY_SUBSCRIPTION_SAGA, workerCopySubscription);
}